import { jwtDecode } from 'jwt-decode';

export interface FirebaseTokenClaims {
  uid: string;
  email?: string;
  email_verified?: boolean;
  exp: number;
  iat: number;
  iss: string;
  sub: string;
  name?: string;
  picture?: string;
  // Hasura custom claims
  'https://hasura.io/jwt/claims'?: {
    'x-hasura-default-role'?: string;
    'x-hasura-allowed-roles'?: string[];
    'x-hasura-user-id'?: string;
    'x-hasura-person-id'?: string;
    'x-hasura-transactor-id'?: string;
  };
  // Additional custom claims
  [key: string]: any;
}

export const decodeIdToken = (token: string): FirebaseTokenClaims => {
  try {
    return jwtDecode<FirebaseTokenClaims>(token);
  } catch (error) {
    console.error('Failed to decode ID token:', error);
    throw new Error('Invalid token format');
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = decodeIdToken(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch {
    return true;
  }
};

export const getTokenExpiryDate = (token: string): Date | null => {
  try {
    const decoded = decodeIdToken(token);
    return new Date(decoded.exp * 1000);
  } catch {
    return null;
  }
};
